// Shared by the browser and the Test migration. Keep existing words when expanding these lists.
const FIRST_WORDS = [
  'Abeto',
  'Bambú',
  'Cedro',
  'Delfín',
  'Enebro',
  'Fresno',
  'Ginkgo',
  'Halcón',
  'Ibis',
  'Jaguar',
  'Kiwi',
  'Lince',
  'Mirlo',
  'Naranjo',
  'Olmo',
  'Pino',
  'Quetzal',
  'Roble',
  'Sauce',
  'Tejo',
  'Urubú',
  'Vencejo',
  'Wombat',
  'Xilófono',
  'Yak',
  'Zorro',
];
const SECOND_WORDS = [
  'Ámbar',
  'Bronce',
  'Coral',
  'Duna',
  'Eclipse',
  'Faro',
  'Granito',
  'Horizonte',
  'Índigo',
  'Jade',
  'Karma',
  'Luna',
  'Marea',
  'Niebla',
  'Ópalo',
  'Prisma',
  'Quimera',
  'Rocío',
  'Sol',
  'Turquesa',
  'Universo',
  'Viento',
  'Wadi',
  'Xenón',
  'Yedra',
  'Zafiro',
];

/** Recognize an assigned alias. This format check is not an authorization check. */
const isPublicAlias = value => {
  if (typeof value !== 'string') return false;
  const parts = value.split(' ');
  return parts.length === 2 && FIRST_WORDS.includes(parts[0]) && SECOND_WORDS.includes(parts[1]);
};

// Rejection sampling keeps every word equally likely when the list length is not a power of two.
const randomWord = words => {
  const value = new Uint32Array(1);
  const limit = 0x100000000 - (0x100000000 % words.length);
  do {
    globalThis.crypto.getRandomValues(value);
  } while (value[0] >= limit);
  return words[value[0] % words.length];
};

/** Generate two independent words, without personal data or a unique identifier suffix. */
const createPublicAlias = () => `${randomWord(FIRST_WORDS)} ${randomWord(SECOND_WORDS)}`;

/** Preserve current aliases; replace legacy names or the previous hexadecimal format on save. */
const ensurePublicAlias = value => (isPublicAlias(value) ? value : createPublicAlias());

module.exports = { createPublicAlias, ensurePublicAlias, isPublicAlias };
